<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
</div>
<div class="content form">

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab label="PUNCHES">
      <div class="punches">
        <form [formGroup]="syncForm" (ngSubmit)="onSubmit()" novalidate>
          <h3>Sincronizar punches</h3>
          <div class="field">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label>Fecha de inicio</mat-label>
              <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="field">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label>Fecha de fin</mat-label>
              <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="actions">
            <button type="submit" mat-flat-button color="primary" [disabled]="syncForm.invalid || loading">
              {{ loading ? 'Sincronizando...' : 'Sincronizar' }}
            </button>
            <button style="margin-left: 8px;" type="button" (click)="viewPunchResults()" mat-flat-button color="primary"
              [disabled]="punchForm.invalid || loading">
              Mirar resultados
            </button>
          </div>
        </form>

        <div class="results">
          <h4>Resultados</h4>
          <pre>{{ punchSyncro | json }}</pre>
        </div>
      </div>

    </mat-tab>

    <mat-tab label="PUNCHES POR DÍA">
      <div class="punches">
        <form [formGroup]="punchForm" (ngSubmit)="onSubmitPunchDay()" novalidate>
          <h3>Selecciona el día</h3>
          <div class="field">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label>Fecha</mat-label>
              <input matInput [matDatepicker]="dayPicker" formControlName="startDate" />
              <mat-datepicker-toggle matSuffix [for]="dayPicker"></mat-datepicker-toggle>
              <mat-datepicker #dayPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="actions">
            <button type="submit" mat-flat-button color="primary" [disabled]="punchForm.invalid || loading">
              {{ loading ? 'Cargando...' : 'Iniciar' }}
            </button>
            <!-- <button style="margin-left: 8px;" type="button" (click)="viewPunchResults()" mat-flat-button color="primary"
              [disabled]="punchForm.invalid || loading">
              Mirar resultados
            </button> -->
          </div>
        </form>

        <div class="results">
          <h4>Resultados</h4>
          <pre>{{ resultPunchByDay | json }}</pre>
        </div>
      </div>

    </mat-tab>

    <mat-tab label="QeQ">
      <div class="punches">
        <h3>Ping a QeQ</h3>
        <button mat-flat-button (click)="pingQeQ()">Probar conexión</button>
        <h4>Resultados</h4>
        <pre>{{ qeqResponse | json }}</pre>
      </div>

    </mat-tab>

    <mat-tab label="USUARIOS">
      <div class="punches">
        <h3>Gestión de Usuarios</h3>
        <button mat-flat-button (click)="manageUsers()">Sincronizar Usuarios</button>
        <h4>Resultados</h4>
        <pre>{{ userManagementResponse | json }}</pre>
      </div>
    </mat-tab>

    <mat-tab label="HEALTH">
      <div class="punches">
        <h3>Ping a Health</h3>
        <button mat-flat-button (click)="pingHealth()">Probar conexión</button>
        <h4>Resultados</h4>
        <pre>{{ healthResponse | json }}</pre>
      </div>

    </mat-tab>

    <mat-tab label="THREADS">
      <div class="punches">
        <h3>Ping a Threads</h3>
        <button mat-flat-button (click)="pingThreads()">Probar conexión</button>
        <h4>Resultados</h4>
        <pre>{{ threadsResponse | json }}</pre>
      </div>

    </mat-tab>


    <mat-tab label="XANCLETES">
      <div class="punches">
        <h3>Sync Xancletes</h3>
        <div class="actions">
          <button mat-flat-button color="primary" (click)="syncXancletes()">Sincronizar</button>
          <button style="margin-left: 8px;" mat-flat-button color="primary" (click)="checkXancletesStatus()"
            [disabled]="!xancletesStatusUrl">
            Mirar resultados
          </button>
        </div>
        <h4>Resultados</h4>
        <pre>{{ xancletesResponse | json }}</pre>
      </div>
    </mat-tab>

    <mat-tab label="INDISPONIBILIDADES">
      <div class="punches">
        <h3>Indisponibilidades</h3>
        <button mat-flat-button (click)="pingIndisponibilidades()">Probar conexión</button>
        <h4>Resultados</h4>
        <pre>{{ IndisponibilidadesResponse | json }}</pre>
      </div>

    </mat-tab>

    <mat-tab label="VERSIONADO APP">
      <div class="punches">
        <h3>Versiones de la Aplicación</h3>
        <form [formGroup]="versionForm" (ngSubmit)="onSubmitVersions()" novalidate>
          <div class="version-field-row">
            <h4>iOS</h4>
            <mat-form-field appearance="outline">
              <!-- <mat-label>iOS</mat-label> -->
              <input matInput formControlName="iosVersion" placeholder="Ej: 1.2.0" />
              <mat-hint>Formato requerido: X.Y.Z (Ej: 1.2.0)</mat-hint>
            </mat-form-field>
            <div class="checkbox-wrapper">
              <mat-label>Habilitado</mat-label>
              <mat-checkbox formControlName="iosEnabled"></mat-checkbox>
            </div>
          </div>
          <div class="version-field-row">
            <h4>Android</h4>
            <mat-form-field appearance="outline">
              <!-- <mat-label>Android</mat-label> -->
              <input matInput formControlName="androidVersion" placeholder="Ej: 1.2.0" />
              <mat-hint>Formato requerido: X.Y.Z (Ej: 1.2.0)</mat-hint>
            </mat-form-field>
            <div class="checkbox-wrapper">
              <mat-label>Habilitado</mat-label>
              <mat-checkbox formControlName="androidEnabled"></mat-checkbox>
            </div>
          </div>
          <div class="actions">
            <button type="submit" mat-flat-button color="primary" [disabled]="versionForm.invalid || loading">
              {{ loading ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </form>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>